<div>

    <div class="jobs-card__item" *ngFor="let job of (showAll ? jobs : jobs | slice:0:visibleCount)" >

        <div class="jobs-card__left">

            <div class="jobs-card__icon">
                <img [src]="getAvatarImageUrl(job)" alt="">
            </div>

            <div class="jobs-card__info">
                <h4 class="jobs-card__title">{{ job.job_title }}</h4>

                <p class="jobs-card__company">
                    {{ job.companyDetails.company_name }}, {{ getCommaSeparatedLocations(job) }}
                </p>

                <div class="jobs-card__salary-row">
                    <span class="jobs-card__salary-text">
                        {{ formatSalary(job) }}
                    </span>

                    <ng-container *ngIf="job.jobTypes && job.jobTypes.length > 0">
                        <span class="jobs-card__salary-chip"
                            *ngFor="let jobType of job.jobTypes | slice:0:2">{{jobType.job_type}}</span>
                    </ng-container>

                </div>
            </div>

        </div>

        <button class="jobs-card__apply-btn" (click)="onClickJob(job)">
            Apply Now
        </button>

    </div>
    <div class="see-more" *ngIf="jobs.length > 8">

        <span  color="primary" class="cursor text-center" (click)="toggleJobs()">
            {{ showAll ? 'See Less' : 'See More' }}
        </span>

    </div>

</div>